<template>
  <div class="app-views">
       <div class="app-item  wow bounceInUpSlow"  data-wow-delay="0.1s">
          <a href="https://www.shmedia.tech/bsapp/" target="_blank">
            <img src="@/assets/images/app/bs-app.png" alt="宝山app">
          </a>
       </div>
       <div class="app-item  wow bounceInUpSlow"  data-wow-delay="0.1s">
          <a href="https://www.shmedia.tech/cmapp/" target="_blank">
            <img src="@/assets/images/app/cm-app.png" alt="崇明 App">
          </a>
       </div>
       <div class="app-item  wow bounceInUpSlow"  data-wow-delay="0.1s">
          <a href="https://www.shmedia.tech/fxapp/" target="_blank">
            <img src="@/assets/images/app/fx-app.png" alt="奉贤 App">
          </a>
       </div>

       <div class="app-item  wow bounceInUpSlow"  data-wow-delay="0.1s">
          <a href="https://www.shmedia.tech/hkapp/" target="_blank">
            <img src="@/assets/images/app/hk-app.png" alt="虹口app">
          </a>
       </div>
       <div class="app-item  wow bounceInUpSlow"  data-wow-delay="0.15s">
          <a href="https://www.shmedia.tech/hpapp/" target="_blank">
            <img src="@/assets/images/app/hp-app.png" alt="黄浦 App">
          </a>
       </div>
       <div class="app-item  wow bounceInUpSlow"  data-wow-delay="0.15s">
          <a href="https://www.shmedia.tech/jaapp/" target="_blank">
            <img src="@/assets/images/app/ja-app.png" alt="静安 App">
          </a>
       </div>

       <div class="app-item  wow bounceInUpSlow"  data-wow-delay="0.15s">
          <a href="https://www.shmedia.tech/jdapp/" target="_blank">
            <img src="@/assets/images/app/jd-app.png" alt="嘉定app">
          </a>
       </div>
       <div class="app-item  wow bounceInUpSlow"  data-wow-delay="0.15s">
          <a href="https://www.shmedia.tech/xhapp/" target="_blank">
            <img src="@/assets/images/app/xh-app.png" alt="徐汇App">
          </a>
       </div>
       <div class="app-item  wow bounceInUpSlow"  data-wow-delay="0.2s">
          <a href="https://www.shmedia.tech/ypapp/" target="_blank">
            <img src="@/assets/images/app/yp-app.png" alt="杨浦App">
          </a>
       </div>
  </div>
</template>
<script setup>

</script>
<style lang="less" scoped>
.app-views{
  display: flex;
  flex-wrap: wrap;
  .app-item{
    width:25%;
    padding:16px;
    a{
      display: block;
      img{
        display: block;
        width:100%;
      }
    }
  }
}
</style>